import { useEffect, useRef, useState } from 'react';

interface IUseInViewOptions {
  threshold?: number;
  root?: Element | null;
  rootMargin?: string;
  enabled?: boolean;
}

export const useInView = <T extends HTMLElement = HTMLElement>(options: IUseInViewOptions = {}) => {
  const { threshold = 0.3, root = null, rootMargin = '0px', enabled = true } = options;

  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);
  const [enterCount, setEnterCount] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el || !enabled) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const isIntersecting = entry.isIntersecting;
        setInView(isIntersecting);
        if (isIntersecting) {
          setEnterCount((c) => c + 1);
        }
      },
      { threshold, root, rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, root, rootMargin, enabled]);

  return { ref, inView, enterCount } as const;
};

export default useInView;
